import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fetchInvoiceByIdQueryOptions } from "@/api/billing";
import { useApiParameters } from "@/hooks/useApiParameters";
import { InvoicePayments } from "../-components/InvoicePayments";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/billing/$invoiceId/payments",
)({
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, invoiceId } = params;

		// Ensure invoice data is loaded
		await context.queryClient.ensureQueryData(
			fetchInvoiceByIdQueryOptions(userId, token, orgId, invoiceId),
		);

		return { userId, token, orgId, invoiceId };
	},
	component: InvoicePaymentsTab,
});

function InvoicePaymentsTab() {
	const { userId, token, orgId, invoiceId } = Route.useLoaderData();

	const { data: invoice } = useSuspenseQuery(
		fetchInvoiceByIdQueryOptions(userId, token, orgId, invoiceId),
	);

	return <InvoicePayments invoice={invoice} token={token} orgId={orgId} />;
}
